import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { ReportToAtlassianButton } from '@atlassian/jira-atlassian-intelligence/src/ui/prompt-response/report-to-atlassian-button/index.tsx';

export function MessageWithFeedbackButton(props: {
	message: string;
	linkText: string;
}): React.JSX.Element {
	const { message, linkText } = props;

	return (
		<>
			<Box xcss={messageWrapperStyles} as="span">
				{message}
			</Box>
			<Box xcss={buttonWrapperStyles}>
				<ReportToAtlassianButton>{linkText}</ReportToAtlassianButton>
			</Box>
		</>
	);
}

const buttonWrapperStyles = xcss({
	display: 'inline-block',
});

const messageWrapperStyles = xcss({
	marginRight: 'space.100',
});
